package dev.alimmz.portfolio.domain.model

data class Project(
    val id: String,
    val title: String,
    val description: String,
    val imageUrl: String,
    val link: String,
    val technologies: List<String>
)

data class Experience(
    val id: String,
    val company: String,
    val position: String,
    val period: String,
    val description: String
)

data class Skill(
    val name: String,
    val category: String,
    val iconUrl: String? = null
)

data class Profile(
    val name: String,
    val role: String,
    val bio: String,
    val githubUrl: String,
    val linkedinUrl: String,
    val email: String
)
